import { Empty, Typography } from "antd";
import React from "react";
import { useTranslate } from "@obsbot/remo-i18n";
import "./index.less";
import EmptyDefaultPNG from "../icons/empty-contact.png";
import EmptyApplyPNG from "../icons/empty-apply.png";

export interface ListEmptyProps {
    modeType?: string;
    emptyImg?: string;
}
export const ListEmpty: React.FC<ListEmptyProps> = ({ modeType, emptyImg = EmptyDefaultPNG }) => {
    const t = useTranslate();
    return (
        <Empty
            description={
                <Typography.Text className="empty-desc">
                    {t("chat.empty-" + modeType)}
                </Typography.Text>
            }
            image={modeType?.includes("apply") ? EmptyApplyPNG : emptyImg}
            styles={{
                image: {
                    height: modeType === "private" ? 50 : modeType?.includes("apply") ? 102 : 165,
                },
            }}
        ></Empty>
    );
};
